'use client';

import { Provider } from 'react-redux';
import type { ReduxAppStore } from './redux-store';

export default function ReduxStoreProvider({
  reduxStore,
  children,
}: {
  reduxStore: ReduxAppStore;
  children: React.ReactNode;
}) {
  return <Provider store={reduxStore}>{children}</Provider>;
}
